import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { DataResult, process, State } from '@progress/kendo-data-query';
import {
    Grid, GridCellProps, GridColumn as Column,
    GridDataStateChangeEvent, GridPageChangeEvent, GridRowProps
} from '@progress/kendo-react-grid';
import {
    GridColumnMenuFilter,
    GridColumnMenuCheckboxFilter,
    GridColumnMenuProps
} from '@progress/kendo-react-grid';
import { products } from './sample-products';
import { useEffect, useState } from 'react';
import { checkTimesheetStatus } from '../../../utils/EllowUtils';
interface PageState {
  skip: number;
  take: number;
}

interface Props {
  data: any;
  counts?: any;
  state?: any;
  pageChange?: any;
  itemChange?: any;
  newpagechange?: any;
  filtereResults?: any;
  }

const ReportsTable1 : React.FC<Props> = (
    {
        data, counts, state, itemChange, filtereResults, pageChange,
    }
  ) => {

  let value1 = data
  let value2 = data
  value2 && value2.length > 0 && value2.map((item: any) => {
    return item.status =  checkTimesheetStatus(item.timesheetStatus).value
   }) 

    const createDataState = (dataState: State) => {
        
        return {
            result: value1 && process(value1.slice(0), dataState),
            dataState: dataState
        };
    }

    let initialState = createDataState({
       
    });

    const checkStatus = (status: string) => {
      switch (status) {
        case '1':
          return {
            value: 'Draft',
            class: 'statusMessage Gray'
          }
        case '2':
          return {
            value: 'Submitted',
            class: 'statusMessage Yellow'
          }
        case '3':
          return {
            value: 'Approved',
            class: 'statusMessage Green'
          }
        case '4':
          return {
            value: 'Rejected',
            class: 'statusMessage Red'
        }
        default:
          return {
            value: '',
            class: ''
        }
      }
    }

    const initialDataState: PageState = { skip: 0, take: 10 };
  
    const [result, setResult] = useState<any>(initialState.result);
    const [dataState, setDataState] = useState<State>(initialState.dataState);
    const [page, setPage] = React.useState<PageState>(initialDataState);

    useEffect(() => {
        if(data){
            setResult(process(data.slice(0), dataState))
            filtereResults(process(data.slice(0), dataState))
        }
    }, [data])
  
  useEffect(() => {  
    if (result) {
      counts(result)  
    }
  }, [result])
    

    const dataStateChange = (event: GridDataStateChangeEvent) => {
        let updatedState = createDataState(event.dataState);
        setResult(updatedState.result);
        setDataState(updatedState.dataState);
        // newpagechange(updatedState)
        filtereResults(updatedState.result)
    }

    
  const ColumnMenuCheckboxFilter = (props: GridColumnMenuProps) => {
       
        return (
          <div>
            <GridColumnMenuCheckboxFilter {...props} data={value2} expanded={true}/>
          </div>
        );
  }
  
  const DateCell = (props: GridCellProps) => {
    return (
      <td>
        {props.dataItem.contractStartDate && new Date(parseInt(props.dataItem.contractStartDate)).toDateString().slice(3)}
      </td>

    )
  }
  const timeSheetStatusCell = (props: GridCellProps) => {
    return (
      <td>
         <div className={checkStatus(props.dataItem.timesheetStatus).class}>
           {checkStatus(props.dataItem.timesheetStatus).value}
        </div>
      </td>
    )
  }

  const rowRender = (
    trElement: React.ReactElement<HTMLTableRowElement>,
    props: GridRowProps
  ) => {
    const est = props.dataItem.maximumPayableAmount;
    const netpay = props.dataItem.candidateOverallPay;
    const green = { backgroundColor: "#C5E9BF" };
    const yellow = { backgroundColor: "#fffcc9" };
    const white = { backgroundColor: "#ffffff"}
    const trProps: any = { style: netpay ? est === netpay ? green : yellow : white };
    return React.cloneElement(
      trElement,
      { ...trProps },
      trElement.props.children
    );
  };

  // const newpagechange = (event: GridPageChangeEvent) => {
  // setState(createState(event.page.skip, event.page.take, result.data))
  // }

  const submittedOnCell = (props: GridCellProps) => {
    return (
      <td>
       {/* { new Date().toLocaleString() } */}
        {props.dataItem.submittedOn ? new Date(parseInt(props.dataItem.submittedOn)).toLocaleString(): ''}
      </td>
    )
  }

  
  const approvedOnCell = (props: GridCellProps) => {
    return (
      <td>
        {props.dataItem.approvedOn ? new Date(parseInt(props.dataItem.approvedOn)).toLocaleString(): ''}
      </td>
    )
  }



    return (
      <Grid
      data={result}
      {...dataState}
      onDataStateChange={dataStateChange}
      // sortable={true}
      pageable={state.pageable}
      rowRender={rowRender}
      pageSize={state.pageSize}
      onItemChange={itemChange}
      // skip={state.skip}
    >
        <Column field="ProductID" title="Employee Id" />
        <Column field="candidateName" title='Candidate name'  />
        <Column field="companyName" title='Client' />
        <Column field="candidateType" title='Type of the candidate' columnMenu={ColumnMenuCheckboxFilter} />
        <Column field="submittedOn" title="Submitted On" cell={submittedOnCell}/>
        <Column field="approvedOn" title="Approved On" cell={approvedOnCell} />
        <Column field="providerName" title="Provider name" />
        <Column field="status" title="Timesheet status" cell={timeSheetStatusCell} columnMenu={ColumnMenuCheckboxFilter}/>
        <Column field="contractStartDate" title="Contract start date" cell={DateCell} />
        <Column field="candidateRate" title="Candidate rate" />
        <Column field="totalWorkingDays" title="Total working days in the month" />
        <Column field="actualWorkingDays" title="Actual working days in the month" />
        <Column field="maximumPayableAmount" title="Maximum payable amount" />
        <Column field="candidateOverallPay" title="Net payable salary" />
        <Column field="difference" title="Difference beween estimate and net" />
      </Grid>
    );
}

export default ReportsTable1;

